//  Copyright (c) 2021 Comsearch, Inc., All rights reserved

import styled from 'styled-components'

export const OptionsWrapper = styled.div`
  background-color: #fff;
  border: thin solid;
  // $blue-dark: #335c84;
  color: #335c84;
  position: absolute;
  right: 100%;
  top: 0;
  transform: translate3d(0, 0, 0) scaleY(0);
  transform-origin: 50% 0;
  transition: transform .3s ease;
  width: 160px;

  &.active {
    transform: translate3d(0, 0, 0) scaleY(1);
  }
`

export const MenuOptionWrapper = styled.p`
  border-bottom: thin solid;
  cursor: pointer;
  display: block;
  padding: .25em;

  &:first-child {
    border-top: thin solid;
  }

  &.disabled {
    //$grey: #e5e6e8;
    background-color: #e5e6e8;
    cursor: not-allowed;
  }

  > img,
  > span {
    display: inline-block;
  }


  > img {
    height: auto;
    max-width: 20px;
  }

  > span {
    border-left: thin solid;
    margin-left: .25em;
    padding-left: .25em;
  }
`
